import { Plugin, PluginKey } from "prosemirror-state";
import { ReactPluginView } from "../../react/react-plugin-view";
import { disableMenu, enableMenu } from "../formatting-toolbar/state";
import { EditorUrlDialogPluginView } from "./components/EditorUrlDialogPluginView";
import { getCurrentLinkData } from "./utils";
const urlDialogPluginKey = new PluginKey("url-dialog");
export const UrlDialogPlugin = (portalContainer) => {
    return new Plugin({
        key: urlDialogPluginKey,
        state: {
            init: () => {
                return { enable: false };
            },
            apply: (tr, value, oldState, state) => {
                var _a, _b;
                const meta = tr.getMeta(urlDialogPluginKey);
                const { from, to } = tr.selection;
                if (meta) {
                    return { enable: meta.enable, target: { from, to } };
                }
                const link = getCurrentLinkData(state);
                if (link && from === to) {
                    // enable dialog if cursor is over a link
                    return {
                        enable: true,
                        target: { from: link.from, to: link.to, mark: link.mark },
                    };
                }
                if (((_a = value.target) === null || _a === void 0 ? void 0 : _a.from) === from && ((_b = value.target) === null || _b === void 0 ? void 0 : _b.to) === to) {
                    // preserve state if selection hasn't changed
                    return value;
                }
                return { enable: false };
            },
        },
        appendTransaction: (trs, oldState, state) => {
            const { enable: oldEnable } = getUrlDialogPluginState(oldState);
            const { enable } = getUrlDialogPluginState(state);
            if (enable === oldEnable) {
                // Do nothing if state hasn't changed
                return;
            }
            // If state changed, enable/disable the floating menu bar if url dialog is opened/closed
            if (enable) {
                return disableMenu(state.tr);
            }
            else {
                return enableMenu(state.tr);
            }
        },
        view: ReactPluginView.create({
            portalContainer,
            component: EditorUrlDialogPluginView,
        }),
    });
};
export const enableUrlDialog = (tr) => tr.setMeta(urlDialogPluginKey, { enable: true });
export const disableUrlDialog = (tr) => tr.setMeta(urlDialogPluginKey, { enable: false });
export const getUrlDialogPluginState = (state) => urlDialogPluginKey.getState(state);
